import { RouteMetadata } from '@mri-platform/shared/core';
import { MenuItem } from '@mri-platform/shared/ui-main-nav-bar';
import { Observable } from 'rxjs';

export abstract class MenuItemService {
  abstract get items(): Observable<MenuItem<RouteMetadata>[]> | MenuItem<RouteMetadata>[];
}

export abstract class MainMenuItemService extends MenuItemService {}
